import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';

import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AddEditBrandmodelComponent } from './addEditBrandmodel.component';

import { BrandmodelModel } from '../../../model/index';
import { BrandmodelService } from '../../../services/index';

@Component({
    selector: 'brandmodel-tab',
    templateUrl: './brandmodel.component.html',
})
export class BrandmodelMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public brandmodeldata: any[] = [];

    isLoadMask: Promise<any>;
    brandmodelData: BrandmodelModel[];
    isLoading: boolean = false;
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(private brandmodelService: BrandmodelService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model Name', prop: 'name', width: 370, minWidth: 370, maxWidth: 370 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 70, maxWidth: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getBrandmodelList();
        }
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getBrandmodelList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getBrandmodelList();
    }

    getBrandmodelList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.brandmodelService
            .getBrandmodelList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.brandmodelData = res.data;
            });
    }

    /* bsModalRef: BsModalRef;
     public addBrandmodel(): void {
         this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
             keyboard: false,
             ignoreBackdropClick: true
         });

         this.bsModalRef.content.title = 'Add BRAND MODEL Details';
         this.bsModalRef.content.mode = 'Add';
         this.bsModalRef.content.brandmodeldata = {};
     }*/
    bsModalRef: BsModalRef;
    onAddEditBrandmodel(mode: string, row: any): void {
        //this.filterPanel.close();
        let that = this;
        if (mode == "Add") {
            row = {
                'brand_id': ''
            }
        }
        row['mode'] = mode;
        this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        this.bsModalRef.content.title = mode + ' Brand Model Details';
        //this.bsModalRef.content.mode = mode;
        this.bsModalRef.content.brandmodeldata = Object.assign({}, row);
        this.bsModalRef.content.brandUpdateEvent.subscribe(($e) => {
            that.getBrandmodelList();
        });
    }
    // onEditBrandmodel(row: any): void {
    //     this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
    //         keyboard: false,
    //         ignoreBackdropClick: true
    //     });
    //     this.bsModalRef.content.brandmodeldata = Object.assign({}, row);
    //     this.bsModalRef.content.title = 'Edit BRAND MODEL Details';
    //     this.bsModalRef.content.mode = 'Edit';
    //     this.bsModalRef.content.brandmodeldata = row;
    //
    // }



    onDeleteBrandmodel(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Brand Model: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.brandmodelService
                .deleteBrandmodel(row.model_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getBrandmodelList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });


        // this.isLoading = true;
        // this.brandmodelService
        //     .deleteBrandmodel(row.model_id)
        //     .then(function(res: any) {
        //         that.isLoading = false;
        //        /* if (res.success) {
        //             that.bsModalRef.hide();
        //         } else {*/
        //             //that.snackBar.open(res.message);
        //             /*var toast = {
        //               type: 'error',
        //               title: 'ERROR',
        //               body: res.message
        //             };
        //
        //             that.toasterService.pop(toast);*/
        //             swal('DELETED SUCCESS', res.message, 'success');
        //         //}
        //
        //     });

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/brandModel/brandmodel.component.ts